// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-RK8","label":"styles_label__2n0WP"};